export default {
  cardButton: {
    clickVisualizar: "Click to view",
    rs: "US$"
  }
};
